// trackActionTypes.js
export const FETCH_IN_PROGRESS_REQUESTS_REQUEST = 'FETCH_IN_PROGRESS_REQUESTS_REQUEST';
export const FETCH_IN_PROGRESS_REQUESTS_SUCCESS = 'FETCH_IN_PROGRESS_REQUESTS_SUCCESS';
export const FETCH_IN_PROGRESS_REQUESTS_FAILURE = 'FETCH_IN_PROGRESS_REQUESTS_FAILURE';

export const FETCH_COMPLETED_REQUESTS_REQUEST = 'FETCH_COMPLETED_REQUESTS_REQUEST';
export const FETCH_COMPLETED_REQUESTS_SUCCESS = 'FETCH_COMPLETED_REQUESTS_SUCCESS';
export const FETCH_COMPLETED_REQUESTS_FAILURE = 'FETCH_COMPLETED_REQUESTS_FAILURE';

export const FETCH_QUERIED_REQUESTS_REQUEST = 'FETCH_QUERIED_REQUESTS_REQUEST';
export const FETCH_QUERIED_REQUESTS_SUCCESS = 'FETCH_QUERIED_REQUESTS_SUCCESS';
export const FETCH_QUERIED_REQUESTS_FAILURE = 'FETCH_QUERIED_REQUESTS_FAILURE';

export const FETCH_REJECTED_REQUESTS_REQUEST = 'FETCH_REJECTED_REQUESTS_REQUEST';
export const FETCH_REJECTED_REQUESTS_SUCCESS = 'FETCH_REJECTED_REQUESTS_SUCCESS';
export const FETCH_REJECTED_REQUESTS_FAILURE = 'FETCH_REJECTED_REQUESTS_FAILURE';
